import { InvisibleSmartCaptcha } from '@yandex/smart-captcha';
import { ComponentProps } from 'react';

type CaptchaProps = Omit<ComponentProps<typeof InvisibleSmartCaptcha>, 'sitekey'>

export const Captcha = (props: CaptchaProps) => {
    return (
        <InvisibleSmartCaptcha
            {...props}
            sitekey={process.env.REACT_APP_CAPTCHA_SITEKEY || ''}
            shieldPosition='bottom-left'
        />)
}